import { render } from "./DeleteConfirmationDialog.vue?vue&type=template&id=64d94959&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"

import "./dialog.scss?vue&type=style&index=0&id=64d94959&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d94959"]])

export default __exports__